import { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'

export default function Tweet({ tweetID }) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (window.twttr) {
      const widgetContainer = document.getElementById('tweet_widget')
      const overlayDiv = document.getElementById('overlay-div')
      if (overlayDiv) {
        overlayDiv.addEventListener('click', (event) => {
          event.stopPropagation()
        })
      }
      window.twttr.widgets
        .createTweet(tweetID, widgetContainer, {
          align: 'center',
          conversation: 'none',
          dnt: true,
          theme: 'light'
        })
        .then(() => setIsLoading(false))
    }
  }, [tweetID])

  return (
    <div className="w-full animate-fadeIn w-100 click-none" id={'tweet_widget'}>
      {isLoading && <Spinner size="md" animation="border" />}
    </div>
  )
}
